export default "__VITE_ASSET__Zzg6kjKd__"